import React, { Component } from 'react';

class Loading extends Component {
  render(){
    return (
      <div
        className={ this.props.className + ' text-center display-4 text-muted w-100' }
      >
        <i className="fas fa-spinner" style={{animation: 'spin 2s linear infinite'}}></i>
      </div>
    );
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/ui-elements/Loading.js